import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) {
  var keys = _Object$keys(object);
  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);
    enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
      return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import { useCallback, useContext, useMemo } from "react";
import { matchPath } from "react-router-dom";
import cx from "classnames";
import { usePathMatch } from "@jutro/platform";
import { isFloorPlanOverride, isFloorPlanDefault } from "./helpers";
import { AppFloorPlanContext } from "./AppFloorPlanProvider";
export default function useFloorPlanMatch(floorPlans) {
  var contextualProps = useContext(AppFloorPlanContext),
    _useMemo = useMemo(function () {
      return [_findInstanceProperty(floorPlans).call(floorPlans, isFloorPlanDefault), _filterInstanceProperty(floorPlans).call(floorPlans, isFloorPlanOverride)];
    }, [floorPlans]),
    _useMemo2 = _slicedToArray(_useMemo, 2),
    defaultFloorPlan = _useMemo2[0],
    floorPlanOverrides = _useMemo2[1],
    getFloorPlanMatch = useCallback(function (pathname) {
      return _findInstanceProperty(floorPlanOverrides).call(floorPlanOverrides, function (_ref) {
        var matches = _ref.matches;
        return (Array.isArray(matches) ? matches : [matches]).some(function (pathMatch) {
          return matchPath(pathname, pathMatch);
        });
      });
    }, [floorPlanOverrides]),
    matchedFloorplanOverride = usePathMatch(getFloorPlanMatch);
  return useMemo(function () {
    var floorPlan = _objectSpread(_objectSpread({}, defaultFloorPlan), matchedFloorplanOverride),
      className = cx(contextualProps.className, floorPlan.className);
    return _objectSpread(_objectSpread(_objectSpread({}, floorPlan), contextualProps), className && {
      className: className
    });
  }, [contextualProps, defaultFloorPlan, matchedFloorplanOverride]);
}